import { localStorageCheck } from './local-storage-check';

export const setToLocalStorage = (name: string, value: string) => {
	if (localStorageCheck()) {
		window.localStorage.setItem(name, value);
	}
};
